import React, { useEffect, useRef } from "react";
import { FaUpRightFromSquare } from "react-icons/fa6";
import gsap from "gsap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';

const MediaCarousel = ({ mediaItems }) => {
  const carouselSectionRef = useRef(null);
  // const carouselRef = useRef(null);
  const headingRef = useRef(null);
  const animationTriggered = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !animationTriggered.current) {
            animationTriggered.current = true;
            animateCarousel();
            if (carouselSectionRef.current) {
              observer.unobserve(carouselSectionRef.current);
            }
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    const currentRef = carouselSectionRef.current; // Capture the ref value

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []); // Dependency array is still empty as intended

  const animateCarousel = () => {
    gsap.fromTo(headingRef.current, {
      yPercent: -20,
      opacity: 0,
    }, {
      yPercent: 0,
      opacity: 1,
      duration: 0.8,
      ease: "power2.out"
    });

    // Animate Swiper Slides
    if (carouselSectionRef.current) {
      const swiperSlides = carouselSectionRef.current.querySelectorAll(".swiper-slide");
      gsap.fromTo(
        swiperSlides,
        {
          yPercent: 20,
          opacity: 0,
        },
        {
          yPercent: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          stagger: 0.15,
          delay: 0.3
        },
      );
    }
  };


  return (
    <div className="bg-black py-12" ref={carouselSectionRef}>
      <div className="max-w-7xl mx-auto md:px-6">
        {/* Heading */}
        <div className="text-center md:text-left mb-10 md:mb-12" ref={headingRef}>
          <h2 className="text-3xl md:text-4xl lg:text-[48px] text-white leading-tight font-medium mb-6">Media</h2>
        </div>

        {/* Swiper Carousel */}
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          loop={true}
          pagination={{ clickable: true }}
          // navigation={true}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          autoplay={{
            delay: 4000,
          }}
          className="md:h-80 h-auto"
        >
          {mediaItems.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className="bg-blue-600 rounded-xl shadow-md hover:shadow-lg h-80 transition-shadow duration-300 overflow-hidden flex flex-col justify-between"
              >
                <div className="p-6 md:min-h-[10rem]">
                  <h3 className="text-xl md:text-2xl font-medium text-white mb-3">{item.title}</h3>
                </div>
                <div className="p-6">
                  <p className="text-sm text-gray-100 mb-4">{item.date}</p>
                </div>
                <div className="p-6 mt-auto">
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-white hover:text-gray-200 font-medium transition-colors duration-200"
                  >
                    READ ARTICLE <FaUpRightFromSquare className="ml-2" />
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default MediaCarousel;